import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// import 'vue-fullpage.js/dist/scrolloverflow.min';
import VueFullPage from 'vue-fullpage.js';
import router from '../src/router/index';
import VueRouter from 'vue-router';
// import '@vime/core/themes/default.css';

Vue.use(VueFullPage);
Vue.use(VueRouter);

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
